import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'

Vue.config.productionTip = false

// 联系方式
Vue.prototype.$Phone = '17767372252'
Vue.prototype.$QQ = '3823151220'
Vue.prototype.$QQGroup = '137912368'
Vue.prototype.$CompanyAddress = '浙江省乐清市天成街道宁康东路2016号(乐清市互联网+精密模具产业园内)'

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
